import { Image, Modal, Text, TouchableOpacity, View } from "react-native";
import React from "react";
import { AppColors } from "../../../utility/AppColors";
import { AppFontStyle } from "../../../styles/AppFontStyle";
import { AppImages } from "../../../utility/AppImages";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Separator from "../../../Components/Separator";

export default function CreateEventModal(props) {
  const { showModal = false, setShowModal, setShowEventTypeModal } = props;
  const deviceSize = useDeviceSize();

  return (
    <Modal
      animationType="fade"
      transparent={true}
      visible={showModal}
      onTouchCancel={() => {
        setShowModal(false);
      }}
    >
      <TouchableOpacity
        style={{
          height: "100%",
          width: "100%",
          justifyContent: "flex-start",
          alignItems: "flex-end",
        }}
      >
        <View
          style={{
            backgroundColor: AppColors.appBlackColor_1e1e1e,
            left:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? -6
                : -60,
            top:
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? 55
                : 130,
            gap: 8,
            padding: 10,
          }}
        >
          <TouchableOpacity
            style={{
              alignItems: "center",
              flexDirection: "row",
              height: 50,
              gap: 15,
              paddingVertical: 10,
              paddingHorizontal: 15,
            }}
            onPress={() => {
              setShowModal(false);
              setShowEventTypeModal(true);
            }}
          >
            <Image
              source={AppImages.icEvent}
              style={{ height: 35, width: 35, resizeMode: "contain" }}
            />
            <Text style={[AppFontStyle.BOLD_ANYBODY_20, { color: "white" }]}>
              Event
            </Text>
          </TouchableOpacity>

          {/* Separater */}
          <Separator
            color={AppColors.grayColor_565656}
            height={2}
            marginTop={0}
            marginBottom={0}
          />

          {/* Tournament Button */}
          <TouchableOpacity
            style={{
              alignItems: "center",
              flexDirection: "row",
              height: 50,
              gap: 15,
              paddingVertical: 10,
              paddingHorizontal: 15,
            }}
            onPress={() => {
              setShowModal(false);
            }}
          >
            <Image
              source={AppImages.icTournament}
              style={{ height: 35, width: 35, resizeMode: "contain" }}
            />
            <Text style={[AppFontStyle.BOLD_ANYBODY_20, { color: "white" }]}>
              Tournament
            </Text>
          </TouchableOpacity>

          {/* Separater */}
          <Separator
            color={AppColors.grayColor_565656}
            height={2}
            marginTop={0}
            marginBottom={0}
          />
        </View>
      </TouchableOpacity>
    </Modal>
  );
}
